<template>
  <div class="abstracts-container">
    <ul>
      <li>Abstract submission deadline – 20 February 2026</li>

      
      <li>
        <!-- <a :href="docxUrl" download="AbstractTemplate.doc">Abstract template</a>
        Word count: 100-300. The content must be in English, and PDF version is required (less than 10 MB). -->
        <a :href="docxUrl" download="AbstractTemplate.docx">Abstract template</a>
      </li>
      <!-- <li>Note: Abstracts will only be reviewed after payment is made. Delegates who submit abstracts are requested to pay their fees as soon as possible.</li>
      -->
    </ul>
    <br>
    <button class="submit-button" @click="onSubmit">Submit</button>
    <br><br><br>


    <!--    <br>
    &lt;!&ndash; <button class="submit-button">Submit11</button> &ndash;&gt;
    <h1>Abstract Submissions</h1>
    <br>
    <div v-for="(abstract, index) in abstracts" :key="index" class="abstract-card">
      <div class="abstract-title">{{ abstract.abstractTitle }}</div>
      <div class="abstract-authors">
        <li v-for="(author, index) in abstract.authorList" :key="index">
          {{"作者"+(index+1) +": " + author.authorName }}
          {{"单位"+(index+1) +": " + author.authorUnit }}
        </li>
      </div>
      <div class="abstract-content">{{ abstract.abstractContent }}</div>
    </div>-->
  </div>


  <!-- 
  <el-dialog title="Information" v-model="dialogVisible" width="50%">
  <el-form :model="form" :inline="true" style="max-width: 100%;"   ref="userForm">
      <el-form :model="form" label-width="auto">
        <el-row>
          <el-col  :span="24">
            <el-form-item label="Title："
                          prop="abstractTitle"
                          :rules="[{ required: true, message: 'Please fill in this field.' }]">
              <el-input v-model="form.abstractTitle" style="width: 600px;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Abstract："
                          prop="abstractContent"
                          :rules="[{ required: true, message: 'Please fill in this field.' }]">
              <el-input v-model="form.abstractContent" type="textarea" style="width: 600px" rows="5"  />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="About Author："
                          prop="aboutAuthor"
                          :rules="[{ required: true, message: 'Please fill in this field.' }]">
              <el-input v-model="form.aboutAuthor" type="textarea" style="width: 600px" rows="5"  />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col>
          <el-form-item label="Are you willing to use the fast-track publication process for the Tropical Plants journal："
                        prop="abstractIsMag"
                        :rules="[{ required: true, message: 'Please choose.' }]">
            <el-radio-group v-model="form.abstractIsMag">
              <el-radio value="1">Yes</el-radio>
              <el-radio value="0">No</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col  :span="7">
          <el-form-item label="Author"
                        v-for="(domain, index) in form.authorList"
                        :key="index"
                        :label="'domain' + index"
                        :prop="'authorList.' + index + '.authorName'"
                        :rules="[{ required: true, message: 'Please fill in this field.' }]">
            <el-input v-model="domain.authorName"/>
          </el-form-item>
        </el-col>
        <el-col  :span="7">
          <el-form-item label="Affiliation"
                        v-for="(domain, index) in form.authorList"
                        :key="index"
                        :label="'domain' + index"
                        :prop="'authorList.' + index + '.authorUnit'"
                        :rules="[{ required: true, message: 'Please fill in this field.' }]">
            <el-input v-model="domain.authorUnit"/>
          </el-form-item>
        </el-col>
        <el-col  :span="7">
          <el-form-item label="E-mail"
                        v-for="(domain, index) in form.authorList"
                        :key="index"
                        :label="'domain' + index"
                        :prop="'authorList.' + index + '.authorEmail'"
                        :rules="[{ required: true, message: 'Please fill in this field.' }]">
            <el-input v-model="domain.authorEmail"/>
          </el-form-item>
        </el-col>
        <el-col  :span="3" >
          <el-form-item label=""
                        v-for="(domain, index) in form.authorList"
                        :key="index"
                        :label="'domain' + index"
                        :prop="'authorList.' + index + '.value'"
          >
            <el-button plain :icon="Delete" @click="deleteAuthor(index)">删除</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col  :span="7">
          <el-form-item>
            <el-button plain :icon="Plus" @click="addAuthor">Add Author</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitAbstract">Submit</el-button>
        <el-button  type="primary"  @click="resetAbstract">Reset</el-button>
      </el-form-item>
      <el-row>
        <el-text class="mx-1" type="info">Clicking "Submit" indicates that the summary will be submitted to the conference academic committee for review.</el-text>
      </el-row>
    </el-form>

  </el-dialog>
   -->


  <el-dialog title="Information" v-model="dialogVisible" width="50%">
  <el-upload class="upload-demo" v-model="dialogVisible" drag action="/api/file/upload" multiple
      :on-success="handleImgUploadSuccess">
      <el-icon class="el-icon--upload"><upload-filled /></el-icon>
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <template #tip>
        <div class="el-upload__tip">
        </div>
      </template>
    </el-upload>

    <el-button type="primary" @click="submitAbstract">Submit</el-button>

  </el-dialog>

</template>

<script>
import { UploadFilled } from '@element-plus/icons-vue'

import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance
} from 'vue'

import { Delete, Plus } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import router from '@/router';
import store from "@/store";
import request from "@/utils/request";
export default {
  setup() {
    const { proxy } = getCurrentInstance();

    const dialogVisible = ref(false);

    const docxUrl = ref('/ictp4/files/AbstractTemplate.docx');

    const abstracts = ref([]);

    const form = reactive({
      abstractTitle: '',
      abstractContent: '',
      aboutAuthor: '',
      abstractIsMag: '',
      authorList: [
        {
          authorName: '',
          authorUnit: '',
          authorEmail: '',
        }
      ],
      userId: '',
      userName: '',
      userFile: ''
    });

    const submitAbstract = async () => {
      console.log("参数11：", form)

      const t = store.getters.user;
      console.log("tt,", t)
      if (t && t.data) {
        form.userId = t.data.id;
        form.userName = t.data.username;
      } else {
        // 允许未登录匿名提交
        form.userId = '';
        form.userName = '';
      }
      try {
        const response = await axios.post("/api/abstract/addUserAbstract", form);
        let res = response.data;
        console.log("请求: ", res);

        if (res.code === "200") {
          ElMessage({
            showClose: true,
            message: '提交成功',
            type: "success",
          });
          resetAbstract();
          dialogVisible.value = false;
        } else {
          ElMessage({
            showClose: true,
            message: res.msg || '提交失败', // 修改为使用返回的msg
            type: "warning",
          });
        }
      } catch (error) {
        console.error("请求错误:", error);
        ElMessage({
          showClose: true,
          message: '网络错误或服务器异常',
          type: "error",
        });
      }
    };

    const handleImgUploadSuccess = (response) => {
      form.userFile = response;
    }

    //新增作者
    const addAuthor = () => {
      form.authorList.push({
        authorName: '',
        authorUnit: '',
        authorEmail: ''
      });
    };

    //删除作者
    const deleteAuthor = (index) => {

      if (form.authorList.length > 1) {
        form.authorList.splice(index, 1);
      } else {
        ElMessage({
          showClose: true,
          message: 'At least one message should be retained.',
          type: 'warning',
        })
      }
    };

    const onSubmit = () => {
      // 不再需要登录，直接打开提交对话框
      dialogVisible.value = true;
    };

    //重置
    const resetAbstract = () => {
      // proxy.$refs.userForm.resetFields();
      form.authorList.splice(1, form.authorList.length - 1);
    };

    const getAllAbstract = () => {
      axios.get("/api/abstract/abstractList").then(res => {
        console.log("res", res.data)

        if (res.data.code === "200") {
          abstracts.value = [];
          abstracts.value = res.data.data
          console.log("res", res.data)
          console.log("abstracts", abstracts)
        }
      })
    };

    onMounted(() => {
      getAllAbstract();
    });


    return {
      Delete, Plus,
      submitAbstract,
      resetAbstract,
      addAuthor,
      deleteAuthor,
      onSubmit,
      form,
      dialogVisible,
      docxUrl,
      abstracts,
      handleImgUploadSuccess
    };
  }
};
</script>

<!-- <script>
import {useRouter} from "vue-router"

export default {
  name: 'Abstract',
  data() {
    return {
      docxUrl: '/files/AbstractTemplate.doc',
      abstracts: [
        {
          title: 'Identification of Genes Regulating Leaf Expansion and Traits Development of Spathiphyllum Plant Based on Full-length Transcriptome Sequencing',
          authors: 'Feixiong Liao',
          institution: 'College of Forestry and Landscape Architecture, South China Agricultural University, Guangdong Key Laboratory for Innovative Development and Utilization of Forest Plant Germplasm',
          content: 'This study focuses on identifying genes that regulate leaf expansion and traits development in Spathiphyllum plants through full-length transcriptome sequencing.',
        },
        {
          title: 'Quality control and product R&D of virgin coconut oil',
          authors: 'Qiuyu Xia',
          institution: 'College of Food Science and Technology, Guangdong Ocean University',
          content: 'The abstract discusses the quality control measures and research and development processes for virgin coconut oil, emphasizing the need for stringent quality standards.',
        },
        {
          title: 'Nitric oxide is involved in melatonin-induced cold tolerance in postharvest litchi fruit',
          authors: 'Jialiang Liu',
          institution: 'College of Food Science and Engineering, Hainan University',
          content: 'This research explores the role of nitric oxide in mediating melatonin-induced cold tolerance in postharvest litchi fruit, aiming to improve fruit storage and quality.',
        },
      ],
    };
  },

  methods: {
    downloadTemplate() {

    },
  },

};
</script> -->

<style scoped>
/* 容器样式 */
.abstracts-container {
  width: 50%;
  /* 整体宽度设为 66% */
  margin: 0 auto;
  /* 水平居中对齐 */
  padding-top: 50px;
  /* 顶部间距 */
}

.submit-button {
  background-color: rgb(178, 213, 223);
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  cursor: pointer;
  border-radius: 6px;
  /* 设置圆角半径 */
  transition: box-shadow 0.3s ease;
  /* 添加过渡效果 */
  /*margin-top: 90px;*/
}

.submit-button:hover {
  background-color: rgb(150, 190, 200);
}

/* 标题样式 */
h1 {
  text-align: center;
  /* 标题居中 */
  color: #333;
  /* 文字颜色 */
}

a {
  color: #3498db;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* 摘要卡片样式 */
.abstract-card {
  background-color: #f9f9f9;
  /* 卡片背景色 */
  border: 1px solid #ddd;
  /* 卡片边框 */
  border-radius: 5px;
  /* 圆角边框 */
  padding: 20px;
  /* 内边距 */
  margin-bottom: 20px;
  /* 卡片之间的间距 */
}

/* 摘要标题样式 */
.abstract-title {
  font-size: 1.2em;
  /* 字体大小 */
  font-weight: bold;
  /* 字体加粗 */
  margin-bottom: 10px;
  /* 标题与内容之间的间距 */
}

/* 作者样式 */
.abstract-authors {
  font-size: 1em;
  /* 字体大小 */
  color: #555;
  /* 文字颜色 */
  margin-bottom: 5px;
  /* 作者与机构之间的间距 */
}

/* 所属机构样式 */
.abstract-institution {
  font-size: 0.9em;
  /* 字体大小 */
  color: #777;
  /* 文字颜色 */
  margin-bottom: 10px;
  /* 机构与内容之间的间距 */
}

/* 摘要内容样式 */
.abstract-content {
  font-size: 0.9em;
  /* 字体大小 */
  color: #333;
  /* 文字颜色 */
}
</style>